import InfluencerModal from './influencer-modal';

export default InfluencerModal;